<script setup lang="ts">
import { ref, onMounted, type Ref } from 'vue';
import {
  useLoadingSpinnerStore,
  RBtn,
} from '@therobotcompany/robco-frontend-library';
import { loadRootGroups } from '@/api/GroupApi';
import type { Group } from '@/models/Group';
import GroupPanel from '@/components/fleet/GroupPanel.vue';
import CreateGroupDialog from '@/components/fleet/CreateGroupDialog.vue';

const loadingSpinnerStore = useLoadingSpinnerStore();
const groups = ref<Group[]>([]);
const error = ref('');
const panelKey = ref(0);
const openPanels: Ref<number[]> = ref([]);
const createDialog = ref(false);

async function getRootGroups() {
  loadingSpinnerStore.setShowLoadingOverlay(true);
  error.value = '';
  try {
    groups.value = await loadRootGroups();
    panelKey.value++;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    error.value = err.message;
  } finally {
    loadingSpinnerStore.setShowLoadingOverlay(false);
  }
}

function openCreateDialog() {
  createDialog.value = true;
}

onMounted(async () => {
  await getRootGroups();
  if (groups.value.length === 1) {
    openPanels.value = [0];
  }
});
</script>

<template>
  <div class="pa-4 pa-sm-12">
    <v-row>
      <v-col cols="12">
        <h1>{{ $gettext('Manage your Robot fleet') }}</h1>
      </v-col>
    </v-row>

    <v-row class="ma-4 ml-0">
      <r-btn variant="outlined" icon="mdi-plus" @click="openCreateDialog">{{
        $gettext('Add Group')
      }}</r-btn>
    </v-row>

    <v-row class="mt-8">
      <v-col cols="12" md="8" lg="6" xl="4">
        <v-alert
          v-if="error"
          class="mt-8"
          border="top"
          icon="mdi-close-circle"
          border-color="error"
        >
          {{ error }}
        </v-alert>
      </v-col>
    </v-row>

    <v-row class="mt-8">
      <v-col cols="12">
        <v-expansion-panels :key="panelKey" v-model="openPanels">
          <template v-for="group in groups" :key="group.uuid">
            <GroupPanel :group="group" @reload-root="getRootGroups" />
          </template>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </div>
  <CreateGroupDialog
    v-model:isOpen="createDialog"
    :parentUuid="null"
    @group-created="getRootGroups"
  />
</template>
